<template>
	<div>
		<v-row>
			<v-col cols="12" md="3">
				<member-profile-header :data="member" @reload="prepareData(false)" :loading="loading" />
			</v-col>
			<v-col cols="12" md="9">
				<v-card v-if="message.length">
					<v-alert type="warning" icon="mdi-shield-lock-outline" outlined>
						{{ message }}
					</v-alert>
				</v-card>
				<div v-else>
					<v-tabs v-model="activeTab" @change="tabChanged" centered background-color="#eee" color="secondary" slider-color="secondary">
						<v-tab :key="0">پرونده وام ها</v-tab>
						<v-tab :key="1">درخواست وام ها</v-tab>
						<v-tab :key="2">تراکنش ها</v-tab>
						<v-tab :key="3">پیامک ها</v-tab>
						<v-tabs-items v-model="activeTab" touchless style="background-color:transparent" class="mt-6">
							<v-tab-item :key="0">
								<member-profile-loan v-for="(loan, index) in loans" :key="index" :data="loan" class="mb-5" @removed="remove" />
							</v-tab-item>
							<v-tab-item :key="1">
								<v-data-table :loading="loanRequestLoading" :headers="headers" :items="loanRequestItems" :footer-props="{ 'items-per-page-options': [5, 15, 50, 100] }" :items-per-page="50" class="elevation-1">
									<template v-slot:item="row">
										<tr>
											<td>
												<div class="info--text" style="cursor:pointer" @click="editLoanRequest(row.item)">
													<span class="text-small info--grey">شماره درخواست:</span> {{ row.item.code }}
												</div>
												<div class="">
													<small class="text-small info--grey">مبلغ: {{ row.item.amount.toString().toPriceFormat() }}</small>
												</div>
												<div class="">
													<small class="text-small info--grey">تاریخ: &lrm;{{ `${row.item.requestDate_Persian.date} ${row.item.requestDate_Persian.time}` }}</small>
												</div>
												<div><small>{{ row.item.loanModel.title }}</small></div>
											</td>
											<td class="text-center">
												{{ row.item.str_Status }}
											</td>
											<td>
												{{ row.item.agentModel ? row.item.agentModel.businessName : '' }}
												{{ row.item.memberModel && row.item.memberModel.marketerName ? row.item.memberModel.marketerName :
													''
												}}
											</td>
											<td class="text-center">
												{{ row.item.agentModel ? row.item.str_AgentStatus : '' }}
											</td>
											<td>
												{{ row.item.adminDescriptionPrivate || "-" }}
											</td>
											<td class="text-center">
												<v-btn class="mx-1" fab dark small color="secondary" @click="editLoanRequest(row.item)">
													<v-icon dark>
														mdi-square-edit-outline
													</v-icon>
												</v-btn>
												<v-btn class="mx-1" fab dark small color="pink" @click="removeLoanRequest(row.item)">
													<v-icon dark>
														mdi-trash-can-outline
													</v-icon>
												</v-btn>
											</td>
										</tr>
									</template>
								</v-data-table>
							</v-tab-item>
							<v-tab-item :key="2">
								<v-card color="white" class="pa-3">
									<online-gateway-payments ref="onlineGatewayPayments" :data="{ memberId: member.id }" :autoLoad="false" />
								</v-card>
							</v-tab-item>
							<v-tab-item :key="3">
								<v-card color="white" class="pa-3">
									<sms-list ref="smsList" :mobile="member.mobile" :autoLoad="false" />
								</v-card>
							</v-tab-item>
						</v-tabs-items>
					</v-tabs>
				</div>
				<div class="text-center mt-2" v-if="activeTab">
					<v-btn class="mx-auto" color="green" dark @click="addLoan">
						<v-icon dark>
							mdi-plus-circle-outline
						</v-icon>
						افزودن وام
					</v-btn>
				</div>
			</v-col>
		</v-row>

		<v-dialog v-model="dialogModifyUserLoan" scrollable persistent max-width="600px">
			<v-card>
				<v-card-title>
					<div><span class="headline">ثبت وام</span></div>
					<v-spacer />
					<v-btn @click="dialogModifyUserLoan = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-user-loan ref="modifyUserLoan" v-if="dialogModifyUserLoan" :data="selectedUserLoan" @callbck="callbck_userLoan" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogLoanRequest" scrollable persistent max-width="1100px">
			<modify-request ref="modifyRequest" v-if="dialogLoanRequest" :data="selectedRequest" @callbck="callbck_loanRequest" @close="dialogLoanRequest = false" />
		</v-dialog>

		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import MemberProfileHeader from '@/components/forms/MemberProfileHeader'
	import MemberProfileLoan from '@/components/forms/MemberProfileLoan'
	import { call, get } from 'vuex-pathify'
	import { emptyId } from '@/util/emptyId'

	export default {
		name: 'MemberProfile',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'sms-list': () => import('@/views/admin/SMSList.vue'),
			'online-gateway-payments': () => import('@/views/admin/Report/OnlineGatewayPayments.vue'),
			'member-profile-header': MemberProfileHeader,
			'member-profile-loan': MemberProfileLoan,
			'modify-user-loan': () => import('@/views/admin/ModifyUserLoan.vue'),
			'modify-request': () => import('./ModifyLoanRequest.vue'),
		},
		data() {
			return {
				activeTab: 0,
				memberId: '',
				loading: false,
				loanRequestLoading: false,
				member: null,
				loans: [],
				message: 'هیچ وامی برای این شخص یافت نشد.',
				selectedUserLoan: null,
				dialogModifyUserLoan: false,
				dialogLoanRequest: false,
				loanRequestItems: [],
				selectedRequest: null,
				headers: [
					{
						text: 'اطلاعات درخواست',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 270
					},
					{
						text: 'وام',
						align: 'start d-none',
						sortable: true,
						value: 'loanModel.title',
					},
					{
						text: 'مبلغ',
						align: 'center d-none',
						sortable: true,
						value: 'amount',
					},
					{
						text: 'تاریخ ثبت درخواست',
						align: 'center d-none',
						sortable: true,
						value: 'requestDate_Persian',
					},
					{
						text: 'وضعیت',
						align: 'center',
						sortable: true,
						value: 'str_Status',
					},
					{
						text: 'نماینده/بازاریاب',
						align: 'center',
						sortable: true,
						value: 'agentModel.businessName',
					},
					{
						text: 'نماینده/بازاریاب',
						align: 'center d-none',
						sortable: true,
						value: 'memberModel.marketerName',
					},
					{
						text: 'وضعیت نماینده',
						align: 'center',
						sortable: true,
						value: 'str_AgentStatus',
					},
					{
						text: 'نظر کارشناس',
						align: 'start',
						sortable: true,
						value: 'adminDescription',
					},
					{
						text: 'عملیات ها',
						align: 'center',
						sortable: false,
						width: 150,
					},
				],
			}
		},
		mounted() {
			this.memberId = this.$route.params.memberId
			this.prepareData()
		},
		computed: {
			isSuperAdmin: get('auth/isSuperAdmin')
		},
		methods: {
			prepareData(loadLoans = true) {
				this.loading = true
				api.get('admin/member/get/' + this.memberId + "/true", null)
					.then(response => {
						this.member = response
						if (loadLoans) {
							this.loadLoans()
						}
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			loadLoans() {
				this.message = 'در حال دریافت اطلاعات وام ها ...'
				api.get('admin/userloan/GetLoansByUserId/' + this.memberId, null)
					.then(response => {
						this.loans = response
						this.message = this.loans.length ? '' : 'هیچ وامی برای این شخص یافت نشد.'
					})
					.catch(err => {
						this.message = 'خطا در دریافت اطلاعات وام ها از سرور'
						toast.error(err.message)
					}).finally(x => {
						this.loading = false
					})
			},
			addLoan() {
				this.dialogModifyUserLoan = true
				this.selectedUserLoan = { id: emptyId, memberModel: this.member }
			},
			remove(userLoanId) {
				let index = this.loans.findIndex(x => x.id == userLoanId)
				if (index > -1) {
					this.loans.splice(index, 1)
				}
			},
			callbck_userLoan(result) {
				this.dialogModifyUserLoan = false
				if (result) { this.loadLoans() }
			},
			tabChanged(tab) {
				if (tab == 1)
					this.loadDataLoanRequest(true)
			},
			loadDataLoanRequest() {
				this.loanRequestLoading = true
				api.get('admin/userLoanRequest/list?memberId=' + this.memberId, null)
					.then(response => {
						this.loanRequestItems = response
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loanRequestLoading = false
					})
			},
			editLoanRequest(item) {
				this.dialogLoanRequest = true
				this.selectedRequest = item
			},
			callbck_loanRequest(result) {
				// this.dialog = false
				if (result) {
					this.loadDataLoanRequest()
				}
			},
			async removeLoanRequest(item) {
				if (!item) {
					return
				}

				if (
					await this.$refs.confirm.open(
						'توجه',
						'آیا از حذف این آیتم مطمئن هستید؟',
					)
				) {
					api
						.post('admin/userLoanRequest/delete/' + item.id)
						.then(response => {
							toast.success('اطلاعات با موفقیت حذف شد.')
							this.loadDataLoanRequest()
						})
						.catch(err => {
							toast.error(err.message)
						})
				}
			},
		},
	}
</script>
<style></style>
